<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="题干">
                  <el-input  style="width: 177px" v-model="queryForm.exerciseName"></el-input>
              </el-form-item>
              <el-form-item label="题目分类">
<!--                  <el-input  style="width: 177px" v-model="queryForm.categoryId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.categoryId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-tree
                          :data="CategoryList"
                          :props="treeProps"
                          :render-after-expand="false"
                      >
                          <div
                              class="custom-tree-node flex items-center"
                              slot-scope="{ node, data }"
                          >
                              <el-option
                                  :label="node.label"
                                  :value="data.id"
                              > </el-option>
                          </div>
                      </el-tree>
                  </el-select>
              </el-form-item>
              <el-form-item label="题目类型">
<!--                  <el-input  v-model="queryForm.exerciseType"></el-input>-->
                  <el-select style="width: 177px" v-model="queryForm.exerciseType" placeholder="请选择题目类型">
                      <el-option
                          v-for="item in videoLocationList"
                          :key="item.value"
                          :label="item.value"
                          :value="item.key"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="科目">
<!--                  <el-input  style="width: 177px" v-model="queryForm.subjectId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      :disabled="eduExerciseState == 'check'"
                      v-model="queryForm.subjectId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-tree
                          :data="eduSubjectList"
                          :props="treeProps2"
                          :render-after-expand="false"
                      >
                          <div
                              class="custom-tree-node flex items-center"
                              slot-scope="{ node, data }"
                          >
                              <el-option
                                  :label="node.label"
                                  :value="data.id"
                              > </el-option>
                          </div>
                      </el-tree>
                  </el-select>
              </el-form-item>
<!--              <el-form-item label="知识点">-->
<!--                  <el-input  v-model="queryForm.knowledgeIds"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="难度程度">-->
<!--                  <el-input  v-model="queryForm.difficulty"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="解析">-->
<!--                  <el-input  v-model="queryForm.analysis"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduExerciseList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduExercise"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduExercise(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduExercise(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduExerciseList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduExerciseList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduExerciseList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exerciseName"
        label="题干"
        width="180"
      >
          <template scope="scope">
              <div v-html="scope.row.exerciseName"></div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryId"
        label="题目分类"
        width="180"
      >
          <template scope="scope">
              {{ scope.row.category ? scope.row.category.categoryName : '' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exerciseType"
        label="题目类型"
        width="180"
      >
          <template scope="scope">
              <span>{{ videoLocationList.find(e=>e.key == scope.row.exerciseType).value }}</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="subjectId"
        label="科目"
        width="180"
      >
          <template scope="scope">
              {{ scope.row.subject ? scope.row.subject.subjectName : '' }}
          </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="knowledgeIds"-->
<!--        label="知识点"-->
<!--        width="180"-->
<!--      >-->
<!--          <template scope="scope">-->
<!--              <span v-for="item in scope.row.knowledges">{{item.knowledgeName}}</span>-->
<!--          </template>-->
<!--      </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="difficulty"
        label="难度程度"
        width="180"
      >
          <template scope="scope">
              <span>{{ startCount.find(e=>e.key == scope.row.difficulty).value }}</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="analysis"
        label="解析"
        width="180"
      >
          <template scope="scope">
              <div v-html="scope.row.analysis"></div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="addRecord(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">习题分析</span>
            </div>
            <div @click="editEduExercise(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduExercise(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduExerciseStates[eduExerciseState]"
      :visible.sync="showDialog"
      width="80%"
      :top="'5vh'"
      custom-class="dialog-box"
      :close-on-click-modal="false"
      @close="closeDialog"
    >

        <EduExercise
            @closeDialog='closeDialog1'
            ref="eduExercise"
            :style="{'height': 'calc(80vh - 100px)', 'overflow-y': 'auto'}"
          :eduExerciseState="eduExerciseState"
        ></EduExercise>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduExerciseState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <!--   习题分析   -->
      <el-drawer
          title="习题分析"
          :visible.sync="showRecordDialog"
          direction="rtl"
          size="70%"
          :before-close="closeRecord">
          <EduExerciseRecord ref="record"></EduExerciseRecord>
      </el-drawer>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { EDUKNOWLEDGE, EDUKNOWLEDGE_SEARCH } from '@/utils/constant';
import WangEditor from '@/components/common/wangeditor.vue';
import EduExercise from '@/components/edu/eduExercise.vue';
import EduCourseOrder from '@/components/edu/EduCourseOrder.vue';
import EduExerciseRecord from '@/components/edu/EduExerciseRecord.vue';

export default {
    components: {
        EduExerciseRecord,
        EduCourseOrder,
        EduExercise,
        WangEditor,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduExerciseList();
                    this.getEduExerciseList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduExerciseList();
                    this.getEduExerciseList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     exerciseName: '', //题干
                     categoryId: '', //题目分类
                     exerciseType: '', //题目类型  1单选 2多选 3判断 4填空 5解答
                     subjectId: '', //科目
                     knowledgeIds: '', //
                     difficulty: '', //难度程度
                     analysis: '', //解析
                },
                EDUKNOWLEDGE_code: EDUKNOWLEDGE,
                EDUKNOWLEDGE_search: EDUKNOWLEDGE_SEARCH,
                CategoryList: [],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduExerciseState: 'add',
                eduExerciseStates: {
                    add: '新建习题',
                    check: '查看习题',
                    edit: '修改习题'
                },
                startCount: [],
                multipleSelection: [],
                eduExerciseList: [],
                eduExercise: {
                    id: '', //
                    exerciseName: '', //题干
                    categoryId: '', //题目分类
                    exerciseType: '', //题目类型  1单选 2多选 3判断 4填空 5解答
                    subjectId: '', //科目
                    knowledgeIds: '', //
                    difficulty: '', //难度程度
                    analysis: '', //解析
                },
                btnLoading: false,
                videoLocationList: [],
                treeProps: {
                    children: 'children',
                    label: 'categoryName'
                },
                eduSubjectList: [],
                treeProps2: {
                    children: 'children',
                    label: 'subjectName'
                },
                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    exerciseName: [{ required: true, message: '题干不能为空', trigger: 'blur' }],
                    categoryId: [{ required: true, message: '题目分类不能为空', trigger: 'blur' }],
                    exerciseType: [{ required: true, message: '题目类型', trigger: 'blur' }],
                    subjectId: [{ required: true, message: '科目不能为空', trigger: 'blur' }],
                    knowledgeIds: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    difficulty: [{ required: true, message: '难度程度不能为空', trigger: 'blur' }],
                    analysis: [{ required: true, message: '解析不能为空', trigger: 'blur' }],
                },
                showRecordDialog: false
            };
        },
        created() {
            this.getEnumList();
            this.getEduExerciseList();
            this.getCategory();
            this.getEduSubjectList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getEduSubjectList(query = {}) {
                get(`/edu/subject/findAllAsTree`).then((res) => {
                    if (res.success) {
                        this.eduSubjectList = res.treeData;
                    }
                });
            },
            addRecord(id){
                this.showRecordDialog = true;
                this.$nextTick(()=>{
                    this.$refs.record.init(id);
                })
            },
            closeRecord(){
                this.showRecordDialog = false;
            },
            getEnumList(){
                get(`/edu/utils/getEnum?enumType=exercise_type`).then((res) => {
                    if (res.success) {
                        this.videoLocationList = res.enumList;
                    }
                });
                get(`/edu/utils/getEnum?enumType=difficulty_level`).then((res) => {
                    if (res.success) {
                        this.startCount = res.enumList;
                    }
                });
            },
            getCategory(){
                get(`/edu/exercisecategory/findAllAsTree`).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.CategoryList = res.treeData;
                    }
                });
            },
            resetEduExerciseList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduExerciseList = [];
            },
            resetDialog() {
                this.eduExerciseState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      exerciseName: '', //题干
                      categoryId: '', //题目分类
                      exerciseType: '', //题目类型  1单选 2多选 3判断 4填空 5解答
                      subjectId: '', //科目
                      knowledgeIds: '', //
                      difficulty: '', //难度程度
                      analysis: '', //解析
                };
                this.getEduExerciseList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduExercise = {
                      id: '', //
                      exerciseName: '', //题干
                      categoryId: '', //题目分类
                      exerciseType: '', //题目类型  1单选 2多选 3判断 4填空 5解答
                      subjectId: '', //科目
                      knowledgeIds: '', //
                      difficulty: '', //难度程度
                      analysis: '', //解析
                };
                this.$refs.eduExercise.closeDia();
                console.log(this.$refs.eduExercise.eduExercise)
            },
            closeDialog1() {
                this.showDialog = false
                this.eduExercise = {
                    id: '', //
                    exerciseName: '', //题干
                    categoryId: '', //题目分类
                    exerciseType: '', //题目类型  1单选 2多选 3判断 4填空 5解答
                    subjectId: '', //科目
                    knowledgeIds: '', //
                    difficulty: '', //难度程度
                    analysis: '', //解析
                };
                this.$refs.eduExercise.closeDia();
                this.refreshEduExerciseList();
            },
            submitForm() {
                this.$refs.eduExercise.submit(this.eduExerciseState);
                return


                if (this.eduExerciseState == 'add') {
                    this.$refs.eduExerciseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exercise/add`,{ ...this.eduExercise }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduExerciseList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduExerciseState == 'edit') {
                    this.$refs.eduExerciseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduExercise.category;
                            delete this.eduExercise.user;
                            delete this.eduExercise.subject;
                            delete this.eduExercise.reply;
                            delete this.eduExercise.choices;
                            delete this.eduExercise.judges;
                            delete this.eduExercise.fillblanks;
                                        post(`/edu/exercise/edit`,{ ...this.eduExercise }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduExerciseList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduExercise() {
                this.showDialog = true;
                this.eduExerciseState = 'add';
                this.$nextTick(()=>{
                    this.$refs.eduExercise.addWat();
                })
                // this.$refs.eduExercise.hei = true;
            },
            checkEduExercise(eduExerciseId) {
                console.log(eduExerciseId);
                this.currentEduExerciseId = eduExerciseId;

                this.getEduExerciseById();
                this.showDialog = true;
                this.eduExerciseState = 'check';
            },
            editEduExercise(eduExerciseId) {
                console.log('eduExercise', eduExerciseId);
                if (eduExerciseId) {
                    this.currentEduExerciseId = eduExerciseId;
                    this.getEduExerciseById();
                } else {
                    this.eduExercise = { ...this.eduExercise, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduExerciseState = 'edit';
            },
            deleteEduExercise(eduExerciseId) {
                let ids = '';
                if (eduExerciseId) {
                    ids = eduExerciseId;
                } else {
                    ids = this.multipleSelection.map((eduExercise) => eduExercise.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/exercise/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduExerciseList();
                                this.getEduExerciseList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduExerciseList() {
                this.resetEduExerciseList();
                this.getEduExerciseList();
            },
            getEduExerciseList(query = {}) {
                this.loading = true;
                get(`/edu/exercise/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduExerciseList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduExerciseById() {
                get(`/edu/exercise/get`,{ id: this.currentEduExerciseId }).then((res) =>{
                    if(res.success){
                      // this.eduExercise = { ...this.eduExercise, ...res.eduExercise };
                        this.$refs.eduExercise.init(res.eduExercise)
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduExerciseList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/exercise/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/exercise/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/exercise/importData`,formData);
              this.refreshEduExerciseList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduExerciseList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduExerciseList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.dialog-box{
    margin-bottom: 0 !important;
}
</style>